var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGooglePlusLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_753_4492)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1 7.65625C14.1 7.16875 14.0563 6.7 13.975 6.25H7.5V8.9125H11.2C11.0375 9.76875 10.55 10.4937 9.81875 10.9812V12.7125H12.05C13.35 11.5125 14.1 9.75 14.1 7.65625Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.4998 14.375C9.35606 14.375 10.9123 13.7625 12.0498 12.7125L9.81855 10.9812C9.20606 11.3937 8.42481 11.6437 7.4998 11.6437C5.71231 11.6437 4.19356 10.4375 3.64981 8.8125H1.3623V10.5875C2.49355 12.8313 4.8123 14.375 7.4998 14.375Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.65 8.80645C3.5125 8.39395 3.43125 7.95645 3.43125 7.5002C3.43125 7.04395 3.5125 6.60645 3.65 6.19395V4.41895H1.3625C0.89375 5.34395 0.625 6.3877 0.625 7.5002C0.625 8.6127 0.89375 9.65645 1.3625 10.5814L3.14375 9.19395L3.65 8.80645Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.4998 3.3625C8.5123 3.3625 9.4123 3.7125 10.1311 4.3875L12.0998 2.41875C10.9061 1.30625 9.35605 0.625 7.4998 0.625C4.8123 0.625 2.49355 2.16875 1.3623 4.41875L3.6498 6.19375C4.19355 4.56875 5.7123 3.3625 7.4998 3.3625Z",
    fill: "#EA4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_753_4492"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlusLogo);
export default __webpack_public_path__ + "static/media/Google-plus-logo.c538981d6fbc2ee327b6ec7cb6fd1359.svg";
export { ForwardRef as ReactComponent };